import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireGlobalAdmin?: boolean;
  requireGlobalUser?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, requireAdmin = false, requireGlobalAdmin = false, requireGlobalUser = false }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireGlobalAdmin) {
    const isGlobalAdmin = user.role === 'admin' && !user.company_id;
    if (!isGlobalAdmin) {
      return <Navigate to="/" replace />;
    }
  } else if (requireGlobalUser) {
    const isGlobalUser = user.company_id == null;
    if (!isGlobalUser) {
      return <Navigate to="/" replace />;
    }
  } else if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
